import { useEffect, useState } from "react";
import { fetchReportSummary } from "../../api/reportApi";
import { ReportSummary } from "../../types/reports/report";
import StatCard from "./StatCard";
import DataTable from "./DataTable";

const ReportDashboard = () => {
  const [month, setMonth] = useState("2026-01");
  const [data, setData] = useState<ReportSummary | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, [month]);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await fetchReportSummary(month);
      console.log(res);
      setData(res);
    } catch (err) {
      console.error(err);
      //alert("Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "24px" }}>
      <h2>Reports Dashboard</h2>

      {/* Month Filter */}
      <label>
        Month:&nbsp;
        <input
          type="month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        />
      </label>

      {loading && <p>Loading...</p>}

      {data && (
        <>
          {/* Stats */}
          <div style={{ display: "flex", gap: "16px", marginTop: "20px" }}>
            <StatCard title="Total Leads" value={data.totalLeads} />
            <StatCard title="Assigned Leads" value={data.assignedLeads} />
          </div>

          {/* Tables */}
          <DataTable
            title="Leads by User"
            data={data.byUser}
            headerLabel="User"
          />

          <DataTable
            title="Leads by Business"
            data={data.byBusiness}
            headerLabel="Business Group"
          />
        </>
      )}
    </div>
  );
};

export default ReportDashboard;
